'use strict';

var App = require('app');

var Modbus = Backbone.Model.extend({
    defaults: {
        modelType: 'modbus',
    },

    initialize: function (options) {
        this.device = options.device;
        this.type = options.type;
        this.modelID = options.modelID;
    },

    url: function () {
        var modelUrl = '/api/v1/devices/' + this.device;

        // edit value or general modbus request?
        if (this.attributes.normalUser === true) {
            return modelUrl + '/values/edit';
        }
        if (this.modelID !== undefined) {
            // .. edit value request
            modelUrl += '/values/' + this.modelID + '/edit';
        } else {
            //modbus request
            modelUrl += '/modbus/' + (this.type != 'apn' ? this.id : '') + '?type=' + this.type;
        }

        return modelUrl;
    },
});

var BatchWriteRequest = Modbus.extend({
    url: function () {
        return '/api/v1/jobs' + (this.jobID ? '/' + this.jobID : '');
    },

    initialize: function (options) {
        this.attributes = {
            action: 'BATCH_VALUE_WRITE',
            arguments: this.attributes,
        };

        this.total = options.total || 0;
        this.success = options.success || 0;
        this.fail = options.fail || 0;
    },

    fetchProgress: function () {
        var def = $.Deferred();
        this.fetch({
            success: function (self, resp) {
                self.total = resp.arguments.devices.length;
                self.success = resp.progress.success || [];
                self.fail = resp.progress.fail || [];
                self.pending = resp.state != 'DONE' && resp.state != 'CANCELED' && resp.state != 'FAILED';

                def.resolve();
            },
            error: function () {
                def.reject();
            },
        });
        return def.promise();
    },
});

var API = {
    doModbusRequest: function (device, type, addr) {
        var defer = $.Deferred();

        var register = new Modbus({ id: addr, device: device, type: type });
        register.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('modbus:request', function (device, type, addr) {
    return API.doModbusRequest(device, type, addr);
});

module.exports = {
    Modbus: Modbus,
    BatchWriteRequest: BatchWriteRequest,
};
